<template>
    <div class="similar-list scroll-tracker">
        <ul>
            <li
                v-for="(item, index) in data"
                :key="index"
                @mouseover="mouseOnSimilar(item)"
                @mouseout="mouseOutSimilar"
                v-show="item.updateState != 'delete'"
            >
                <Checkbox class="all-check" @valueChange="checkHandler($event, item)" :data="item.checked" />
                <input class="que-li-input" @input="vertify" @keypress="keyPressHandler" :class="{ editing: currentId === item.extQuestionId }" v-model="editVal" />
                <div class="que-li-txt" v-show="currentId !== item.extQuestionId">{{ item.extQuestion }}</div>
                <i class="i-class-edit" @click="editClick(item)" v-show="showEditorBtn && item.extQuestionId === onMouseoverId" v-if="isEdit"></i>
            </li>
        </ul>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";

export default {
    name: "SimilarList",
    props: ["data", "unableEdit"],
    data() {
        return {
            currentId: "",
            currentVal: "",
            editVal: "",
            showEditorBtn: false,
            onMouseoverId: ""
        };
    },
    components: {
        Checkbox
    },
    computed: {
        isEdit() {
            return this.unableEdit ? !this.unableEdit : true;
        }
    },
    methods: {
        checkHandler(event, data) {
            this.$emit("checkChange", {
                checked: event.checked,
                extQuestion: data.extQuestion,
                extQuestionId: data.extQuestionId
            });
        },
        editClick(item) {
            setTimeout(() => {
                this.currentVal = item.extQuestion;
                this.editVal = item.extQuestion;
                this.currentId = item.extQuestionId;

                setTimeout(() => {
                    let input = document.querySelector(".similar-list .editing.que-li-input");
                    input && input.focus();
                }, 50);
            }, 50);
        },
        emitEditEvent() {
            const newText = this.zhiji.strTrim(this.editVal);
            const isChanged = newText != this.currentVal;
            newText &&
                isChanged &&
                this.$emit("similarEditClick", {
                    extQuestionId: this.currentId,
                    extQuestion: newText
                });
            this.currentId = "";
        },
        vertify () {
            const newEditVal = this.editVal;
            if (newEditVal.search(/[<>]/g) !== -1) {
                this.editVal = newEditVal.replace(/[<>]/g, '');
                this.$message({
                    message: this.$t("zhiji.knowlege.quesEditModal.editSimilarWarning"),
                    type: 'warning',
                });
            }
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.emitEditEvent();
        },
        windowClick(event) {
            if (!!this.currentId && this.zhiji.isClickOuter(event, "que-li-input")) {
                this.emitEditEvent();
            }
        },
        mouseOnSimilar(item) {
            this.onMouseoverId = item.extQuestionId;
            this.showEditorBtn = true;
        },
        mouseOutSimilar() {
            this.showEditorBtn = false;
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};
</script>

<style lang="less" scoped>
.editing {
    display: block !important;
}
.similar-list {
    flex: 1;
    background: #fff;
    overflow-y: auto;

    .que-li-txt {
        height: 32px;
        line-height: 32px;
        max-width: 80%;
        margin-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .que-li-input {
        display: none;
        width: 35%;
        margin-right: 10px;
        border: solid 1px #d8e4f0;
        box-sizing: border-box;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding-left: 8px;
        &:focus {
            border-color: #2088f3;
        }
    }
    li {
        display: flex;
        align-items: center;
        position: relative;
        padding: 8px 0 8px 24px;
        border-bottom: 1px solid #d8e4f0;
        cursor: pointer;
        .all-check {
            margin-right: 20px;
        }
        &:hover {
            background: rgba(217, 235, 246, 0.7);
        }
        &:last-child {
            border: none;
        }
        .i-class-edit {
            position: relative;
            display: inline-block;
            width: 18px;
            height: 18px;
            margin: 0 5px 0 5px;
            vertical-align: middle;
            background: url("@{zhijiStaticImagePath}class-spr.png");
            background-position: -76px 0;
            &:hover {
                background-position: -76px -22px;
            }
        }
    }
}
</style>
